
import cInput from "@/components/FormElements/CustomInput.vue";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ebSelect from "@/components/FormElements/Select.vue";


@Component({
    components: {
        cInput,
        ebSelect,
    },
})
export default class Agreement extends Vue {
    get marketOptions() {
        return [
            {
                label: "Domain",
                value: "DOMAIN",
            },
            {
                label: "Market",
                value: "MARKET",
            },
        ];
    }
    get getwayoption() {
        return [
            {
                label: "COD",
                value: "COD",
            },
            {
                label: "Cash Free",
                value: "CASHFREE",
            },
            {
                label: "Paytm",
                value: "PAYTM",
            },
        ];
    }

    get catalogsOptions() {
        let catalogs = this.$store.getters["catalog/GetCatalogTree"];
        let filtercatalogs = [];
        if (this.agreement.market === null) {
            return [];
        } else if (this.agreement.market.value === "DOMAIN") {
            filtercatalogs = catalogs.filter((obj) => obj.isDomain);
            return filtercatalogs;
        } else if (this.agreement.market.value === "MARKET") {
            filtercatalogs = catalogs.filter((obj) => obj.isMarket);
            return filtercatalogs;
        } else if (this.agreement.market.value === "Product_Type") {
            filtercatalogs = catalogs.filter((obj) => obj.isProductType);
            return filtercatalogs;
        } else if (this.agreement.market.value === "Category") {
            filtercatalogs = catalogs.filter((obj) => obj.isCategory);
            return filtercatalogs;
        }
    }
    @Watch("agreement.keys")
    onChange(newVal, oldVal) {
        this.agreement.paymentOptionKeys = [];
        newVal.forEach((element) => {
            this.agreement.paymentOptionKeys.push(element.value);
        });
    }

    private agreement: any = {
        enableManufacturer: false,
        paymentOptionKeys: [],
        keys: "",
        appkeyCashFree: "",
        secretkeyCashFree: "",
        appkeyPaytm: "",
        secretkeyPaytm: "",
        market: null,
        catalog: null,
        doc: "",
        valid: {
            from: new Date(),
            to: new Date(),
        },
    };
    private readAgreement(e) {
        this.uploadFile(e.target.files[0]);
    }

    // upload file to the S3 bucket
    private async uploadFile(file) {
        let formdata = new FormData();
        formdata.append("file", file);
        formdata.append(
            "key",
            (
                Date.now().toString(36) +
                Math.random().toString(36).substr(2, 5)
            ).toLowerCase(),
        );
        formdata.append("isPublic", JSON.stringify(true));
        formdata.append("replaceExisting", JSON.stringify(true));
        formdata.append("basePath", "tenant");
        this.showCustomToast();
        await this.$store
            .dispatch("inventory/uploadFileToStorage", formdata)
            .then((res) => {
                this.agreement.doc = res.data.fileUrl;
            })
            .catch((error) => {
                this.$swal({
                    type: "error",
                    text: "File Upload failed! please try again.",
                });
                this.clearCustomToast();
            });
    }
    private showCustomToast() {
        Vue.toasted.show("Uploading...", {
            type: "info",
            theme: "toasted-primary",
            singleton: true,
            duration: 1000,
        });
    }
    private clearCustomToast() {
        Vue.toasted.clear();
    }

    private mounted() {
        this.$store.dispatch("catalog/fetchCatalogTree");
    }
}
